import includes from 'ramda/src/includes';

export const isIncludeGmh = includes("gmh");
